import { createSlice } from "@reduxjs/toolkit";

// Helper function to safely get the token from local storage
const getInitialToken = () => {
  try {
    const token = localStorage.getItem('access_token');
    return token || null; // Return the token if found, otherwise null
  } catch (error) {
    console.error("Error accessing local storage:", error);
    // In case of an error (e.g., localStorage not available in some environments),
    // we default to null
    return null;
  }
};

const initialState = {
  // Initialize the token from local storage
  token: getInitialToken(),
};

export const authSlice = createSlice({
  name: "auth_token",
  initialState,
  reducers: {
    setUserToken: (state, action) => {
      state.token = action.payload.token;
      // Also save the token to local storage when it's set
      try {
        localStorage.setItem('access_token', action.payload.token);
      } catch (error) {
        console.error("Error saving token to local storage:", error);
      }
    },
    unSetUserToken: (state) => { // Removed action.payload.token as it's not needed for unsetting
      state.token = null;
      // Remove the token from local storage when it's unset
      try {
        localStorage.removeItem('access_token');
      } catch (error) {
        console.error("Error removing token from local storage:", error);
      }
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUserToken, unSetUserToken } = authSlice.actions;

export default authSlice.reducer;